var render = function () {
  var _vm$author, _vm$author$thumb, _vm$author2, _vm$author2$thumb, _vm$author3, _vm$author3$name;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-card', {
    attrs: {
      "flat": "",
      "tile": "",
      "to": "/artists/".concat(_vm.author._id)
    }
  }, [_c('v-img', {
    class: {
      'v-sheet--outlined': !((_vm$author = _vm.author) === null || _vm$author === void 0 ? void 0 : (_vm$author$thumb = _vm$author.thumb) === null || _vm$author$thumb === void 0 ? void 0 : _vm$author$thumb.url)
    },
    attrs: {
      "src": (_vm$author2 = _vm.author) === null || _vm$author2 === void 0 ? void 0 : (_vm$author2$thumb = _vm$author2.thumb) === null || _vm$author2$thumb === void 0 ? void 0 : _vm$author2$thumb.url,
      "aspect-ratio": 1 / 1,
      "width": "100%"
    },
    scopedSlots: _vm._u([{
      key: "placeholder",
      fn: function fn() {
        return [_c('v-overlay', {
          attrs: {
            "absolute": "",
            "dark": "",
            "color": "transparent"
          }
        }, [_c('v-icon', {
          attrs: {
            "color": "grey",
            "size": "40"
          }
        }, [_vm._v("mdi-account")])], 1)];
      },
      proxy: true
    }])
  }), _c('v-card-title', [_vm._v(_vm._s((_vm$author3 = _vm.author) === null || _vm$author3 === void 0 ? void 0 : (_vm$author3$name = _vm$author3.name) === null || _vm$author3$name === void 0 ? void 0 : _vm$author3$name.ko))]), _c('v-divider', {
    staticClass: "primary"
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }